import React from 'react';

const GettingStartedConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/gettingstarted',
      component: React.lazy(() => import('./GettingStarted')),
    },
  ],
};

export default GettingStartedConfig;
